
import { Component, Vue } from 'vue-facing-decorator'
import { LockDec, ValidateDec } from '@/decorators';

@Component({})
export default class extends Vue {
  loading = false;
  submitLoading = false;

  formData = {
    name: "",
    isDefault: false,
    senderName: "",
    senderMobile: "",
    province: "",
    city: "",
    county: "",
    address: "",
  }

  /** 省市区在表单里是三个字段，级联组件收发的是一整个数组，这里来回转一下 */
  get areaValue() {
    return [this.formData.province, this.formData.city, this.formData.county];
  }
  set areaValue(v) {
    let list = v || [];
    this.formData.province = list[0] || "";
    this.formData.city = list[1] || "";
    this.formData.county = list[2] || "";
  }

  get mesureId() {
    return this.$route.query.id
  }

  async created() {
    this.loading = true;
    await this.getData();
    this.loading = false;
  }

  async getData() {
    let id = this.mesureId;
    if (!id) return;
    let { error, data } = await this.$post("/manager/warehouse/detail", {
      id,
    });
    if (error) return;
    /** isDefault 从库里出来可能是个 0/1，el-switch 只认布尔，这里统一一下 */
    this.formData = { ...this.formData, ...data, isDefault: !!data.isDefault };
  }

  @ValidateDec("form", { showTips: true })
  @LockDec("submitLoading")
  async submit() {
    await this.$postNotify(this.mesureId ? "/manager/warehouse/edit" : "/manager/warehouse/add", {
      ...this.formData,
      id: this.mesureId,
    });
    this.$router.back();
  }
}
